export default __webpack_public_path__ + "static/media/multiple_manufacturing_processes_1.20b0f4b8.png";